<script>
import { Line } from "vue-chartjs/legacy";

export default {
  name: "LineChart",
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    setTimeout(() => {
      this.renderChart(this.chartdata, this.options);
    }, 500);
  },
};
</script>